/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Module-scoped callback so ReCharge listeners can update the sticky price
  let updateStickyAtcPrice = null;
  // Tracks whether the ReCharge subscription option is currently selected
  let rcSubscriptionActive = false;
  // Reference to the ReCharge discounted price element, set after widget loads
  let rcPriceEl = null;

  document.addEventListener('DOMContentLoaded', function() {
    const stickyAtc = document.querySelector('.sticky-add-to-cart');
    
  
    if (stickyAtc) {
      let stickyButton = stickyAtc.querySelector('.sticky-atc');
      let stickyPrice = stickyAtc.querySelector('.sticky-atc--price');
      let stickyBtnPrice = stickyAtc.querySelector('.sticky-atc--btn-price');
      let stickyVariantId = stickyButton.dataset.variantId;

      updateStickyAtcPrice = function(text) {
        if (stickyPrice) stickyPrice.textContent = text;
        if (stickyBtnPrice) stickyBtnPrice.textContent = ' • ' + text;
      };
      let productOptions = document.querySelectorAll('.product__selectors .radio__input');
      const productSubmitHolder = document.querySelector('.product__submit__holder');
      console.log('productSubmitHolder', productSubmitHolder);


      const stickyVariantLabel = stickyAtc.querySelector('.sticky-atc--variant');

      const getSelectedVariantTitle = () => {
        const seen = {};
        const parts = [];
        document.querySelectorAll('.product__selectors .radio__input:checked').forEach(function(input) {
          if (!seen[input.name]) {
            seen[input.name] = true;
            parts.push(input.value);
          }
        });
        return parts.join(' / ');
      };

      const handleOptionChange = (optionValue, optionPrice) => {
        stickyVariantId = optionValue;
        if (rcSubscriptionActive && rcPriceEl) {
          // Subscription is active — wait for ReCharge to recalculate the
          // discounted price for the newly selected variant, then read it.
          setTimeout(function() {
            const subPrice = [...rcPriceEl.childNodes]
              .filter(function(n) { return n.nodeType === Node.TEXT_NODE; })
              .map(function(n) { return n.textContent.trim(); })
              .join('');
            if (subPrice && updateStickyAtcPrice) updateStickyAtcPrice(subPrice);
          }, 400);
        } else {
          if (updateStickyAtcPrice) updateStickyAtcPrice(optionPrice);
        }
        if (stickyVariantLabel) {
          stickyVariantLabel.textContent = getSelectedVariantTitle();
        }
      }

      productOptions.forEach(option => {
        option.addEventListener('change', function() {
          let optionChecked = option.checked;
          let selectedOptionVariantId = option.dataset.optionId;
          let selectedOptionVariantPrice = option.dataset.optionPrice;
          if(optionChecked) {
            handleOptionChange(selectedOptionVariantId, selectedOptionVariantPrice);
          }
        });
      });

      stickyButton.addEventListener('click', function() {
        const mainAtcBtn = document.querySelector('[data-add-to-cart]');
        if (mainAtcBtn) {
          mainAtcBtn.click();
        } else {
          handleAddToCart(stickyVariantId, 1);
        }
      });

      let handleAddToCart = (variantId, quantity) => {
        const data = {
          id: variantId,
          quantity: quantity
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(() => {
            // window.refreshCart();
        })
        .catch(error => {
            console.error(error);

        });
      }


      let handleStickyVisibility = (holder) => {
        let observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            let rect = entry.boundingClientRect;
            if (rect.bottom <= 0) {
              if(!stickyAtc.classList.contains('sticky-add-to-cart--visible')) {
                stickyAtc.classList.add('sticky-add-to-cart--visible');
              }
            } else {
              if(stickyAtc.classList.contains('sticky-add-to-cart--visible')) {
                stickyAtc.classList.remove('sticky-add-to-cart--visible');
              }
            }
          });
        }, { threshold: 0 });

        if (holder) {
          observer.observe(holder);
        }
      }
  
      handleStickyVisibility(productSubmitHolder);
    }


    // Product Grid Item Add To Cart 
    const addToCartButtons = document.querySelectorAll('.fr-add-to-cart--button');

    let collectionHandleAddToCart = (variantId, quantity) => {
      const data = {
        id: variantId,
        quantity: quantity
      };
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(() => {
          // window.refreshCart();
      })
      .catch(error => {
          console.error(error);

      });
    }

    addToCartButtons.forEach(button => {
      button.addEventListener('click', function() {
        const variantId = button.dataset.variantId;
        collectionHandleAddToCart(variantId, 1);
      });
    });
    
  });
let rechargeWidget = document.querySelector('recharge-subscription-widget');
let productPrice = document.querySelector('.product__price .product__price--regular ');

if(rechargeWidget) {
  setTimeout(() => {
    let oneTimePurchase = rechargeWidget.shadowRoot.querySelector('.rc-purchase-option.rc-selection__onetime');
    let subscriptionPurchase = rechargeWidget.shadowRoot.querySelector('.rc-purchase-option.rc-purchase-option__subscription');

    if(oneTimePurchase) {
      oneTimePurchase.addEventListener('click', function() {
        rcSubscriptionActive = false;
        let oneTimeProductPrice = oneTimePurchase.querySelector('.rc-price');
        let oneTimeProductPriceText = [...oneTimeProductPrice.childNodes]
          .filter(node => node.nodeType === Node.TEXT_NODE)
          .map(node => node.textContent.trim())
          .join('');
        productPrice.innerText = oneTimeProductPriceText;
        if (updateStickyAtcPrice) updateStickyAtcPrice(oneTimeProductPriceText);
      });
    }

    if (subscriptionPurchase) {
      let priceEl = subscriptionPurchase.querySelector('.rc-price[part="rc-purchase-option__discounted-price"]');
      rcPriceEl = priceEl;
      priceEl.addEventListener('onchange', function() {
        console.log('subscriptionPurchase', subscriptionPurchase);
      });
      subscriptionPurchase.addEventListener('click', function () {
        rcSubscriptionActive = true;
        let subscriptionProductPrice = [...priceEl.childNodes]
          .filter(node => node.nodeType === Node.TEXT_NODE)
          .map(node => node.textContent.trim())
          .join('');
        productPrice.innerText = subscriptionProductPrice;
        if (updateStickyAtcPrice) updateStickyAtcPrice(subscriptionProductPrice);
      });
    }
  }, 1000);
}

  var PRICE_SELECTOR  = '[data-product-price]'; // adjust to actual price element
  var POINTS_SELECTOR = '[id*="smile_io_smile_points_on_product_page"] p'; // adjust to actual Smile points text element

  function parsePrice(text) {
    var match = text.replace(/,/g, '').match(/[\d.]+/);
    return match ? parseFloat(match[0]) : null;
  }

  function initPDPPointsWidget() {
    var priceEl = document.querySelector(PRICE_SELECTOR);
    var pointsEl = document.querySelector(POINTS_SELECTOR);
    console.log({priceEl, pointsEl});
    if (!priceEl || !pointsEl) return;

    var initialPrice = parsePrice(priceEl.textContent);
    var initialPoints = parseInt(pointsEl.textContent.replace(/[^\d]/g, ''), 10);
    if (!initialPrice || !initialPoints) return;

    var ratio = initialPoints / Math.floor(initialPrice); // points earned per dollar, inferred from page itself

    var observer = new MutationObserver(function () {
      var currentPrice = parsePrice(priceEl.textContent);
      console.log({currentPrice});
      if (currentPrice == null) return;
      var newPoints = Math.floor(currentPrice * ratio);
      console.log({newPoints});
      pointsEl.textContent = pointsEl.textContent.replace(/\d+/, newPoints);
    });

    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', initPDPPointsWidget);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
